// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationEnterPinPath = 'M70.786 27.723V43h-6.931V27.861C63.855 20.206 57.649 14 49.994 14c-7.656 0-13.862 6.206-13.862 13.861V43h-6.93V27.723c0-11.483 9.308-20.792 20.792-20.792 11.483 0 20.792 9.309 20.792 20.792zm-13.862.138V43H43.063V27.861a6.93 6.93 0 0113.861 0zm-34.653-.138V43H13.36v34.822a10.396 10.396 0 002.178 6.336L24.45 95.94a10.495 10.495 0 008.317 4.06H67.22a10.496 10.496 0 008.317-4.06l8.911-11.782a10.396 10.396 0 002.178-6.336V43h-8.91V27.723C77.716 12.412 65.304 0 49.993 0 34.683 0 22.27 12.412 22.27 27.723zm-1.98 50.099V50h59.406v27.822c-.02.746-.261 1.47-.694 2.079l-9.01 11.782a3.366 3.366 0 01-2.772 1.386H32.766a3.366 3.366 0 01-2.772-1.386l-9.01-11.782a3.762 3.762 0 01-.693-2.08zm27.722-8.515a4.95 4.95 0 11-9.9 0 4.95 4.95 0 019.9 0zm8.911 4.95a4.95 4.95 0 100-9.9 4.95 4.95 0 000 9.9zm13.862 0a4.95 4.95 0 100-9.9 4.95 4.95 0 000 9.9zm-41.584 0a4.95 4.95 0 100-9.9 4.95 4.95 0 000 9.9z';
var IllustrationEnterPin = baseIllustration('IllustrationEnterPin', {
  getPath: () => IllustrationEnterPinPath
}, 'ColoredIllustrationEnterPin');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationEnterPin;
//# sourceMappingURL=index.js.map